import React from "react"
import { MessageCircle } from "lucide-react"
import { ContactData } from "../types/objects"
import { INQUIRY_EMAIL, OFFER_PDF_URL } from "../data/products"

/**
 * Props interface for Footer component
 */
interface FooterProps {
	data?: ContactData
}

/**
 * Footer Component — company/legal identification, contact summary, support hours and site links.
 * Mirrors the static footer in public/index.html.
 */
export const Footer: React.FC<FooterProps> = ({ data = {} }) => {
	const companyName = data.companyName || "B2B Technological Insight s.r.o."
	const ico = data.ico || "23126213"
	const vatNote = data.vatNote || "Nejsme plátci DPH."
	const address = data.address || "Legerova 1815/33, 120 00 Praha 2"
	const email = (data.email || "m.snajdr@b2btechinsight.cz").trim()
	const inquiryEmail = INQUIRY_EMAIL
	const phone = data.phone || "602 255 575"
	const phoneDigits = phone.replace(/\s+/g, "")
	const whatsapp = data.whatsapp || "420602255575"
	const hours = data.hours || "pondělí–pátek 9:00–17:00"
	const responseTime = data.responseTime || "odpovídáme do 24 hodin v pracovní dny"
	const year = new Date().getFullYear()

	return (
		<footer id="footer" className="lp-footer">
			<div className="lp-container">
				<div className="lp-footer__grid">
					<div>
						<div className="lp-footer__brand">
							<img src="/img/b2bticon.png" alt="" aria-hidden="true" />
							<span>B2B Insight</span>
						</div>
						<p>
							{companyName}<br />
							IČO: {ico}<br />
							{address}<br />
							{vatNote}
						</p>
					</div>

					<div>
						<h4>Kontakt</h4>
						<p>
							<a href={`mailto:${email}`}>{email}</a><br />
							Poptávky: <a href={`mailto:${inquiryEmail}`}>{inquiryEmail}</a><br />
							<a href={`tel:${phoneDigits.startsWith("+") ? phoneDigits : `+420${phoneDigits}`}`}>{phone}</a><br />
							<a href={`https://wa.me/${whatsapp}`} target="_blank" rel="noopener noreferrer" style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
								<MessageCircle size={15} /> WhatsApp
							</a>
						</p>
					</div>

					<div>
						<h4>Dostupnost podpory</h4>
						<p>
							Telefon a WhatsApp: {hours}<br />
							E-mail: {responseTime}<br />
							Kritický incident (SLA): reakce do 4 h
						</p>
					</div>

					<div>
						<h4>Informace</h4>
						<ul>
							<li><a href="/o-nas.html">O nás</a></li>
							<li><a href="/clanky/">Články</a></li>
							<li><a href="#products">Produkty</a></li>
							<li><a href={OFFER_PDF_URL} target="_blank" rel="noopener noreferrer">Nabídka řešení (PDF)</a></li>
							<li><a href="#inquiry">Sestavit poptávku</a></li>
							<li><a href="#pricing">Ceník</a></li>
							<li><a href="#faq">Časté dotazy</a></li>
							<li><a href="/zaruka.html">Záruka a SLA</a></li>
							<li><a href="/obchodni-podminky.html">Obchodní podmínky</a></li>
							<li><a href="/ochrana-osobnich-udaju.html">Ochrana osobních údajů</a></li>
						</ul>
					</div>
				</div>

				<div className="lp-footer__bottom">
					<span>&copy; {year} {companyName}. Všechna práva vyhrazena.</span>
					<span>Optimalizace procesů · Integrace systémů · AI</span>
				</div>
			</div>
		</footer>
	)
}
